import { useCallback, useState } from 'react';

const normalizeLocationError = (errorCode) => {
  switch (errorCode) {
    case 1:
      return 'location_denied';
    case 2:
      return 'location_unavailable';
    case 3:
      return 'location_timeout';
    default:
      return 'location_failed';
  }
};

const useBrowserLocation = () => {
  const [coords, setCoords] = useState(null);
  const [isLocating, setIsLocating] = useState(false);
  const [locationError, setLocationError] = useState('');
  const [hasRequestedLocation, setHasRequestedLocation] = useState(false);

  const requestLocation = useCallback(() => {
    if (typeof window === 'undefined' || !navigator?.geolocation) {
      setLocationError('location_unsupported');
      setHasRequestedLocation(true);
      return;
    }

    setIsLocating(true);
    setLocationError('');
    setHasRequestedLocation(true);

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setCoords({
          latitude: Number(position.coords.latitude),
          longitude: Number(position.coords.longitude),
        });
        setIsLocating(false);
      },
      (error) => {
        setLocationError(normalizeLocationError(error?.code));
        setIsLocating(false);
      },
      {
        enableHighAccuracy: true,
        timeout: 12000,
        maximumAge: 120000,
      }
    );
  }, []);

  return {
    coords,
    isLocating,
    locationError,
    hasRequestedLocation,
    requestLocation,
  };
};

export default useBrowserLocation;
